var SCM = SCM || {};
SCM.CustomQueryBuilder = (function($) {

    return {
        init: init,
        queryBuilderHandler: queryBuilderHandler
    };

    function init() {
        // register handler
        $('.js-querybuilder-add-term').off('click').on('click', addTermClick);
    }
  
    function addTermClick() {
       
        // show next instance of QueryBuilder
        var $nextToShow = $('.querybuilder-instance.hide:first');
        var $operatorsInstanceID = $nextToShow.find('.operator-options');
        var $andOp;
        if ($operatorsInstanceID !== undefined && $operatorsInstanceID.length > 0) {
            $operatorsInstanceID.removeClass('hide');
            var $andOp = $operatorsInstanceID.find('input[id^="andOp-qbInstance"]');
            $andOp.prop('checked', true);
        }
        $nextToShow.removeClass('hide');
        if ($andOp) {
            $andOp.focus();
        }
        else {
            $('#queryBuilderSubmit').focus();
        }
        if ($('.querybuilder-instance.hide').length === 0) {
            $('.js-querybuilder-add-term').attr('disabled', '');
        }
    }

    function queryBuilderHandler() {
        var queryString = '';
        var currentDataUrl = $('.querybuilder-submit').attr('data-current-url');
        var oldQueryParams = currentDataUrl.split('&');
        // strip out params since we're starting a new query and cqb
        var paramsToRemove = ['fd_IsLatestEdition', 'cqb', 'qb', 'page', 'q'];

        var queryParams = oldQueryParams.filter(function (el) {
            var paramType = el.split('=')[0];
            return paramsToRemove.indexOf(paramType) < 0;
        });

        queryParams = buildQB(queryParams);

        queryParams.push('page=1');
        var param = queryParams.filter(function (el) {
            return el.startsWith('searchType');
        });
        if (!param) {
            queryParams.push('searchType=advanced');
        }
        param = queryParams.filter(function (el) {
            return el.startsWith('adv');
        });
        if (!param) {
            queryParams.push('adv=true');
        }

        queryString = queryParams.join('&');
        return queryString;

    }

    function buildQB(queryParams) {
        var jsonObj = [];

        var group = {};
        var terms = [];

        var qbObject = {};
        var instanceIndex = 1;
        var qbObjectInitialized = false;
        var $operator;

        $('.querybuilder-wrap .querybuilder-instance').not('.hide').each(function () {
            var $this = $(this);
            //find the search term 
            var $qbInputElement = $this.find('input[id^="instance_QueryBuilderSearchTerm"]');
            var qbInputElementVal = $qbInputElement.val().trim();

            // if an uneven number of quotes, remove them all so backend doesn't choke
            if ((qbInputElementVal.match(/\"/g) || []).length % 2 !== 0) {
                qbInputElementVal = qbInputElementVal.replace(/\"/g, '');
            }

            // remove quotes for processing
            var qbSearchTerm = qbInputElementVal.replace(/^"(.*)"$/, '$1');
            var searchTerm = encodeURIComponent(qbSearchTerm);

            // Only process the terms that have values
            if (qbSearchTerm.length > 0) {

                var keyOperatorOrdinal = 'qOp' + instanceIndex;
                // add conditional to the group (if exists)
                if ($operator !== undefined && $operator.length > 0) {
                    qbObject[keyOperatorOrdinal] = $operator.val();
                }

                var exactMatch = false;
                // If it has quotes, it's an exact match
                if (/[^']*'$/.test(qbInputElementVal) || /[^"]*"$/.test(qbInputElementVal)) {
                    exactMatch = true;
                }

                //get the text and value for the selected radio button
                var qbSearchTypeFieldName = '';
                var $qbSearchTypeFieldOption = $this.find('input[name^="querybuilder-facet-"]:checked');
                if ($qbSearchTypeFieldOption.length) {
                    qbSearchTypeFieldName = $qbSearchTypeFieldOption.val(); 
                }

                var term = {};
                $operator = $this.find('[name^=operator-]:checked');
                // add conditional to the group (if exists)
                if ($operator !== undefined && $operator.length > 0) {
                    // if OR, create a new grouping
                    if ($operator.val() === 'OR') {
                        if (terms.length) {
                            // ensures that the first term in a group does not contain the condition property
                            if (terms[0].condition) {
                                delete terms[0].condition;
                            }
                            group['terms'] = terms;
                            jsonObj.push(group);
                            terms = [];
                            group = {};
                        }
                        group['condition'] = $operator.val();
                    }
                    else {
                        term['condition'] = $operator.val();
                    }
                    qbObject[keyOperatorOrdinal] = $operator.val();
                }

                term['filter'] = qbSearchTypeFieldName;
                term['input'] = searchTerm;
                if (exactMatch) {
                    term['exactMatch'] = true;
                }
                terms.push(term);

                if (qbInputElementVal.trim() !== '') {
                    var key = qbSearchTypeFieldName + instanceIndex;

                    if (qbSearchTypeFieldName === '') {
                        // No filter selected
                        key = 'q';
                        if (instanceIndex !== 1) {
                            key = key + instanceIndex;
                        }
                    }
                    if (exactMatch) {
                        key = key + '-exact';
                    }
                    qbObject[key] = searchTerm;
                    qbObjectInitialized = true;
                }
                instanceIndex++;
            }    
        });
        if (terms.length) {
            // ensures that the first term in a group does not contain the conditon property
            if (terms[0].condition) {
                delete terms[0].condition;
            }
            group['terms'] = terms;
            jsonObj.push(group);
        }
        // ensures that the first group in the obj does not contain the condition property
        if (jsonObj.length) {
            if (jsonObj[0].condition) {
                delete jsonObj[0].condition;
            }
        }

        var jsonObjStr = JSON.stringify(jsonObj);
        queryParams.push('cqb=' + jsonObjStr);
        if (qbObjectInitialized) {
            var qbObjectParmsStr = JSON.stringify(qbObject);
            queryParams.push('qb=' + qbObjectParmsStr);
        }
        return queryParams;
    }

})(jQuery);